module.exports = __webpack_public_path__ + "img/thinking.54d5dd24.png";